/**
 * Borrower phone list — LOS-aligned helpers (phoneNumbers[] + legacy phone).
 */

export const BORROWER_PHONE_TYPES = ['Mobile', 'Home', 'Work', 'Other'];

/**
 * Same rule as GET: Mobile first if present; otherwise first numbered entry; else legacy phone.
 * @param {{ phoneNumbers?: Array<{ phoneType?: string, number?: string }>, phone?: string | null }} borrower
 * @returns {string | null}
 */
export function derivePrimaryPhoneNumber(borrower) {
  if (!borrower) return null;
  const list = borrower.phoneNumbers || [];
  const mobile = list.find((p) => p.phoneType === 'Mobile' && (p.number || '').trim());
  if (mobile) return mobile.number.trim();
  const first = list.find((p) => (p.number || '').trim());
  if (first) return first.number.trim();
  const legacy = borrower.phone;
  return legacy && String(legacy).trim() ? String(legacy).trim() : null;
}
